import Layout from '../../layout';
const specialTopicRouter = {
	path: '/',
	component: Layout,
	redirect: '/',
	name: 'eduSpecialTopic',
	meta: {
		title: '1',
		sort: 4,
	},
	children: [
		{
			path: '/specialTopic',
			component: () =>
				import('@/pages/ideological/views/specialTopic/index.vue'),
			name: 'specialTopic',
		},
		{
			path: '/hotContent',
			component: () =>
				import('@/pages/ideological/views/hotContent/index.vue'),
			name: 'hotContent',
		},
		{
			path: '/specialTopicNoLeft',
			component: () =>
				import(
					'@/pages/ideological/views/specialTopicNoLeft/index.vue'
				),
			name: 'specialTopicNoLeft',
		},
	],
};

export default specialTopicRouter;
